module dg.modules.users {

    export interface IUser extends dg.domain.IDomainObject {
        aggregateId: string;
        userName: string;
        displayName: string;
        pendingSystemNotificationCount: number;
        pendingUserTasksCount: number;
        isPilot: boolean;
    }

    export interface IUserInfo {
        isAuthenticated: boolean;
        userName: string;
        profile: {
            aud: string;
            iss: string;
            iat: number;
            nbf: number;
            exp: number;
            ver: string;
            tid: string;
            amr: Array<string>;
            oid: string;
            upn: string;
            ub: string;
            given_name: string;
            family_name: string;
            name: string;
            unique_name: string
                nonce: string;
            pwd_exp: string;
            pwd_url: string;
        };
    }

    angular.module('dg.modules.users', []);
}